import { Box, Button, Stack, Typography } from "@mui/material";
import templeIcon from "../../../assets/temple-icon.png";
import locationIcon from "../../../assets/loc-icon.png";
import { LOCALIZATION } from "../../../utils/localization";
import { t } from "i18next";
import ImageView from "../../ImageView/ImageView";

export default function LiveDarshan(props: any) {
  const boxDefaultCss = {
    borderRadius: "12px",
    backgroundColor: "#FFFFFF",
    margin: "0px",
    color: "#767676",
    width: "100%",
    padding: "8px",
  };
  return (
    <>
      {/* {templeData.map((item, index) => ( */}
      <Box
        key={"asd"}
        className="liveDarshanCardDesign"
        style={{
          borderRadius: props.borderRadius || boxDefaultCss.borderRadius,
          backgroundColor:
            props.backgroundColor || boxDefaultCss.backgroundColor,
          margin: props.margin || boxDefaultCss.margin,
          color: props.color || boxDefaultCss.color,
          width: props.width || boxDefaultCss.width,
          padding: props.padding || boxDefaultCss.padding,
        }}
      >
        <Box className="liveDarshanCardLt">
          <Box className="mandirImgB">
            <ImageView src={props.image} alt="Temple" />
          </Box>

          <Box className="mandirDetails">
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
              className="twoItem"
            >
              <Box className="templeIcon">
                <img src={templeIcon} alt="Temple Icon" />
              </Box>
              <Box className="templeName">
                <Typography>{props.name}</Typography>
              </Box>
            </Stack>

            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
              className="twoItem"
            >
              <Box className="locationIcon">
                <img src={locationIcon} alt="Location Icon" />
              </Box>
              <Box className="templeName">
                <Typography>{props.location}</Typography>
              </Box>
            </Stack>
          </Box>

          <Box className="clickDarshan">
            <Button
              variant="contained"
              onClick={() => props.goToTempleDarshan(props.templeData?.id)}
            >
              {t(LOCALIZATION.Darshan)}
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
}
